export default {
    settings: {
        title: 'GLOBAL SETTINGS',
        mainMenu: 'Main menu',
        footerMenu: 'Footer menu',
        phone: 'Phone',
        fax: 'Fax',
        email: 'E-mail',
        address: 'Address',
        city: 'City',
        categoryId: 'Category IDs',
        numDocument: 'Num. of documents per category',
        save: 'Save'
    },
    menu: {
        position: 'Position',
        parent: 'Parent',
        pageOfUrl: 'Page of URL'
    }
};